import React, { useEffect, useState } from 'react';
import ProgressBar from '../ProgressBar/ProgressBar';
import { checkUserExists } from '../../actionCreators/offerCampaign';
import { connect } from 'react-redux';
import { sendValidateOtp } from '../../actionCreators/auth';
import { getPincodeData } from '../../actionCreators/address';
import LeadGenThankYou from '../ThankYou/LeadGenThankyou';
import { saveLeadGenData } from '../../actionCreators/common';
import { extractUtmSourceFromUrl } from '../../utils/helper';
import LeadGenForm from './LeadGenForm';

const LeadGen = props => {
  const { dataLocale, localeInfo, userInfo, leadGenSuccess, login, redisCommonData } = props;
  const [step, setStep] = useState(1);
  const [showSuccessScreen, setShowSuccessScreen] = useState(false);
  const formConfig = {
    showEmail: true,
    showName: true,
    showPhone: true,
    showCity: true,
    emailMandatory: true,
    nameMandatory: true,
    phoneMandatory: true,
  };
  const [formValue, setFormValue] = useState(null);
  const [currentPhoneCode, setCurrentPhoneCode] = useState(localeInfo.phoneCode);
  const isDesktop = Boolean(process.env.CLIENT_TYPE === 'desktop');
  let lkUserType = '';
  let loginStatus = '';
  const trackingDetail = (data, stepName, lkUserType, loginStatus) => {
    const {
      utm_source = null,
      utm_medium = null,
      utm_campaign = null,
      utm_term = null,
      utm_content = null,
    } = extractUtmSourceFromUrl(props.location.search);
    if (utm_source) {
      localStorage.setItem(
        'utmSource',
        JSON.stringify({ utm_source, utm_medium, utm_campaign, utm_term, utm_content })
      );
    } else if (!localStorage.getItem('utmSource')) {
      localStorage.setItem(
        'utmSource',
        JSON.stringify({ utm_source, utm_medium, utm_campaign, utm_term, utm_content })
      );
    }
    const utmSource = JSON.parse(localStorage.getItem('utmSource'));
    const dlUpdate = {
      event: 'Lead Generation Form',
      PageUrl: location.href,
      pageName: stepName,
      pageType: 'Lead Generation',
      mobile: btoa(data?.mobileNumber || data?.phone || ''),
      email: btoa(data?.email || ''),
      loginStatus: loginStatus || '',
      lkUserType: lkUserType || '',
      utmSource: utmSource.utm_source || '(direct)',
      utmMedium: utmSource.utm_medium || '(none)',
      utmCampaign: utmSource.utm_campaign || '(direct)',
      utmTerm: utmSource.utm_term || '',
      utmContent: utmSource.utm_content || '',
    };
    if (typeof window.dataLayer !== 'undefined') window.dataLayer.push(dlUpdate);
    else {
      setTimeout(() => {
        window.dataLayer.push(dlUpdate);
      }, 2000);
    }
  };
  const totalStep = 1;
  const progressTitle = {
    1: dataLocale.WE_ARE_HERE_TO_ASSIST_YOU,
  }[step];

  const submitUserForm = formData => {
    const { saveLeadGenData } = props;
    const { name, email, mobileNumber, city } = formData || {};
    const {
      utm_source = null,
      utm_medium = null,
      utm_campaign = null,
    } = extractUtmSourceFromUrl(props.location.search);
    if (utm_source) {
      localStorage.setItem('utmSource', JSON.stringify({ utm_source, utm_medium, utm_campaign }));
    } else if (!localStorage.getItem('utmSource')) {
      localStorage.setItem('utmSource', JSON.stringify({ utm_source, utm_medium, utm_campaign }));
    }
    const utmSource = JSON.parse(localStorage.getItem('utmSource'));
    const finalData = {
      email: email || '',
      phone: mobileNumber || '',
      phoneCode: currentPhoneCode || '',
      name: name || '',
      location: city || '',
      utmSource: utmSource.utm_source || '(direct)',
      utmMedium: utmSource.utm_medium || '(none)',
      utmCampaign: utmSource.utm_campaign || '(direct)',
    };
    setTimeout(() => {
      if (typeof window.clevertap !== 'undefined') {
        window.clevertap.event.push('Page Visited', {
          'Page Name': dataLocale.LEADGEN_USER_DETAIL,
          Phone: `${currentPhoneCode}${finalData.phone}`,
        });
      }
    }, 500);
    saveLeadGenData(finalData);
    setFormValue(formData);
    const initialLocation = window.location.origin;
    window.history.pushState('', '', `${initialLocation}/lead-gen/thankyou`);
  };

  useEffect(() => {
    const { leadGenData } = props;
    lkUserType = userInfo?.hasPlacedOrder ? 'lkRepeat' : 'lkNew';
    loginStatus = login ? 'loggedIn' : 'guest';
    if (leadGenSuccess) {
      setStep(2);
      trackingDetail(leadGenData, dataLocale.LEADGEN_THANKYOUPAGE, lkUserType, loginStatus);
      setShowSuccessScreen(true);
      if (typeof window.clevertap !== 'undefined') {
        window.clevertap.onUserLogin.push({
          Site: {
            name: formValue.name,
            Identity: leadGenData?.phone,
            Email: leadGenData?.email,
            Phone: `${leadGenData?.phoneCode}${leadGenData?.phone}`,
            'MSG-email': true,
            'MSG-push': true,
            'MSG-sms': true,
            'MSG-whatsapp': true,
          },
        });
        window.clevertap.event.push('Page Visited', {
          'Page Name': dataLocale.LEADGEN_THANKYOUPAGE,
          Phone: `${currentPhoneCode}${leadGenData?.phone}`,
        });
        const {
          utm_source = null,
          utm_medium = null,
          utm_campaign = null,
        } = extractUtmSourceFromUrl(props.location.search);
        if (utm_source) {
          localStorage.setItem(
            'utmSource',
            JSON.stringify({ utm_source, utm_medium, utm_campaign })
          );
        } else if (!localStorage.getItem('utmSource')) {
          localStorage.setItem(
            'utmSource',
            JSON.stringify({ utm_source, utm_medium, utm_campaign })
          );
        }
        const utmSource = JSON.parse(localStorage.getItem('utmSource'));
        window.clevertap.event.push('Lead Capture', {
          utm_source: utmSource.utm_source || '(none)',
          utm_medium: utmSource.utm_medium || '(none)',
          utm_campaign: utmSource.utm_campaign || '(none)',
          City: leadGenData.location,
        });
      }
    } else {
      trackingDetail(leadGenData, dataLocale.LEADGEN_USER_DETAIL, lkUserType, loginStatus);
    }
  }, [leadGenSuccess]);

  const backToHome = () => {
    props.history.push('/');
  };
  return (
    <div>
      {step !== 2 &&
        (!isDesktop ? (
          <ProgressBar step={step} title={progressTitle} totalStep={totalStep} />
        ) : (
          <div className="fs20 text-center margin-t40">{dataLocale.WE_ARE_HERE_TO_ASSIST_YOU}</div>
        ))}
      <React.Fragment>
        {!showSuccessScreen &&
          {
            1: (
              <div className="pd-20">
                <LeadGenForm
                  dataLocale={dataLocale}
                  formConfig={formConfig}
                  localeInfo={localeInfo}
                  redisCommonData={redisCommonData}
                  setCurrentPhoneCode={setCurrentPhoneCode}
                  submitDetails={submitUserForm}
                />
              </div>
            ),
          }[step]}
      </React.Fragment>
      {showSuccessScreen && (
        <LeadGenThankYou
          backToHome={backToHome}
          buttonText={dataLocale.EXPLORE_COOL_SPECS}
          message={dataLocale.WE_WILL_REACH_OUT_SOON}
        />
      )}
    </div>
  );
};

function mapStateToProps(state) {
  return {
    redisCommonData: state.common.redisCommonData,
    dataLocale: state.locale,
    loading: state.auth.loading,
    localeInfo: state.common.localeInfo,
    leadGenData: state.common.leadGenData,
    userInfo: (state.common.userInfo && state.common.userInfo.result) || null,
    currencyMark: state.common.currencyMark,
    locationServiceDetails: state.hto.locationServiceableDetails,
    leadGenSuccess: state.common.leadGenDataSuccess,
    login: state.common.login,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    sendValidateOtp: data => dispatch(sendValidateOtp(data)),
    getPincodeData: pincode => dispatch(getPincodeData(pincode)),
    checkUserExists: data => dispatch(checkUserExists(data)),
    saveLeadGenData: data => dispatch(saveLeadGenData(data)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LeadGen);
